import {
  Avatar,
  Button,
  FormControl,
  FormControlLabel,
  Input,
  MenuItem,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Compressor from "compressorjs";
import Constants from "../../../data/Constants";
import {
  getSingleMentor,
  createSingleMentor,
  updateSingleMentor,
} from "../../../services/mentor.service";
import Utils from "../../../utils";
import { getIn, useFormik } from "formik";
import * as yup from "yup";
import Validation from "data/Validation";

const defaultMentor = {
  firstname: "",
  lastname: "",
  email: "",
  mobile: "",
  bankName: "",
  accountHolderName: "",
  accountNumber: "",
  accountType: "",
  ifsc: "",
  address: "",
  education: "",
  profession: "",
  experience: "",
  counsellingCostPrice: 0,
  counsellingSalePrice: 0,
  isCounsellingEnabled: false,
  languages: [],
  skills: [],
  description: "",
  status: "",
};

function EditMentor(props) {
  const { id } = useParams();
  const navigate = useNavigate();

  const { setProgress, setToast } = useOutletContext();
  const validationSchema = yup.object({
    firstname: yup.string().required().label("Firstname").min(2).max(100),
    lastname: yup.string().required().label("Lastname").min(2).max(100),
    email: yup.string().required().label("Email").email(),
    mobile: yup
      .string()
      .required()
      .label("Mobile")
      .matches(Validation.REGEX_MOBILE_INDIAN, "Mobile is not a valid number"),
    bankName: yup.string().nullable().label("Bank Name").min(2).max(100),
    accountHolderName: yup
      .string()
      .nullable()
      .default(undefined)
      .label("Account Holder Name")
      .min(2)
      .max(100),
    accountNumber: yup
      .string()
      .nullable()
      .default(undefined)
      .label("Account Number")
      .matches(Validation.REGEX_ACCOUNT_NUMBER, "Account Number is not valid"),

    ifsc: yup
      .string()
      .nullable()
      .default(undefined)
      .label("Account Number")
      .matches(Validation.REGEX_IFSC, "IFSC Code is not valid"), // SBIN0125620

    accountType: yup
      .string()
      .nullable()
      .default(undefined)
      .label("Account Type")
      .oneOf(["current", "saving"]),

    address: yup
      .string()
      .nullable()
      .required()
      .label("Address")
      .min(2)
      .max(100),

    education: yup
      .string()
      .nullable()
      .required()
      .label("Education")
      .min(2)
      .max(100),
    profession: yup
      .string()
      .nullable()
      .required()
      .label("Profession")
      .min(2)
      .max(100),

    experience: yup.string().nullable().required().label("Experience").max(100),

    isCounsellingEnabled: yup.boolean().required().label("Counselling Enabled"),

    counsellingCostPrice: yup
      .number()
      .default(0)
      .when(["isCounsellingEnabled"], (isCounsellingEnabled) => {
        if (isCounsellingEnabled) {
          return yup
            .number()
            .default(0)
            .required()
            .label("Counselling Cost Price");
        } else {
          return yup.number().default(0);
        }
      }),

    counsellingSalePrice: yup
      .number()
      .default(0)
      .when(
        ["counsellingCostPrice", "isCounsellingEnabled"],
        (counsellingCostPrice, isCounsellingEnabled) => {
          if (!isCounsellingEnabled) {
            return yup.number().default(0);
          }
          return yup
            .number()
            .default(0)
            .required()
            .label("Counselling Sale Price")
            .max(
              counsellingCostPrice,
              "Counselling Sale Price should be less than or equal to Cost Price"
            );
        }
      ),

    description: yup
      .string()
      .required()
      .label("Long Description")
      .min(1)
      .max(4000),

    status: yup
      .string()
      .required()
      .label("Mentor Status")
      .oneOf(Constants.Mentor.Status),
  });

  const formik = useFormik({
    initialValues: defaultMentor,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);
      formSubmitHandler(values);
    },
  });

  const formSubmitHandler = async (values) => {
    // client validations

    // if (res.profilePictureFile) {
    //   res.picture = URL.createObjectURL(res.profilePictureFile);
    // }
    console.log("clicked");
  
    try {
      setProgress(true);
      const res = id
        ? await updateSingleMentor(id, values)
        : await createSingleMentor(values);

      setProgress(false);

      if (id) {
        setToast({ success: true, message: "Mentor Successfully Updated" });
      } else {
        navigate("/dashboard/mentors/edit/" + res._id);
        setToast({ success: true, message: "Mentor Successfully Created" });
      }
    } catch (error) {
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  const handleFile = (e) => {
    const image = e.target.files[0];
    new Compressor(image, {
      quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
      success: (compressedResult) => {
        // compressedResult has the compressed file.
        var file = new File(
          [compressedResult],
          compressedResult.name,
          compressedResult
        );

        console.log(file);
        console.log(URL.createObjectURL(file));

        formik.setFieldValue("profilePictureFile", file);
        formik.setFieldValue("picture", URL.createObjectURL(file));
      },
    });
  };

  useEffect(() => {
    async function api() {
      if (id) {
        try {
          setProgress(true);
          const res = await getSingleMentor(id);
          if (res) {
            console.log(res);

            formik.setValues(res);
            setProgress(false);
          } else {
            // error
            setToast({ error: true, message: Constants.Error.UNKNOWN });
            setProgress(false);
          }
        } catch (error) {
          // error

          console.log(error);
          setProgress(false);
          setToast({ error: true, message: Utils.CustomErrorMessage(error) });
        }
      }
    }
    api();
  }, []);

  return (
    <form onSubmit={formik.handleSubmit}>
      {
        <div className="grid grid-cols-2">
          <div>
            <h1 className="p-4 font-extrabold text-lg">Basic Details</h1>
            <div className=" p-5 grid-cols-2 grid gap-5">
              <TextField
                label="Firstname"
                variant="filled"
                size="small"
                name="firstname"
                value={formik.values.firstname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.firstname && Boolean(formik.errors.firstname)
                }
                helperText={formik.touched.firstname && formik.errors.firstname}
                required
              />
              <TextField
                label="Lastname"
                variant="filled"
                size="small"
                name="lastname"
                value={formik.values.lastname}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.lastname && Boolean(formik.errors.lastname)
                }
                helperText={formik.touched.lastname && formik.errors.lastname}
                required
              />
              <TextField
                label="Email"
                type="email"
                variant="filled"
                size="small"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                required
              />
              <TextField
                label="Mobile"
                type="mobile"
                variant="filled"
                size="small"
                name="mobile"
                value={formik.values.mobile}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                helperText={formik.touched.mobile && formik.errors.mobile}
                required
              />
              <div className="grid grid-cols-2 col-span-2">
                <div className="flex items-center justify-center">
                  {
                    <Avatar
                      src={formik.values.picture}
                      sx={{ width: 100, height: 100 }}
                    />
                  }
                </div>

                <div>
                  <h1 className="font-bold py-4">Upload Profile Picture</h1>
                  <Input
                    type="file"
                    name="profilePictureFile"
                    accept="image/*"
                    style={{ margin: "10px 0" }}
                    onChange={handleFile}
                  />
                </div>
              </div>
            </div>
            <h1 className="p-4 font-extrabold text-lg">Account Details</h1>

            <div className=" p-5 grid-cols-2 grid gap-5">
              <TextField
                label="Bank Name"
                variant="filled"
                size="small"
                name="bankName"
                value={formik.values.bankName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.bankName && Boolean(formik.errors.bankName)
                }
                helperText={formik.touched.bankName && formik.errors.bankName}
              />

              <TextField
                label="Account Holder Name"
                variant="filled"
                size="small"
                name="accountHolderName"
                value={formik.values.accountHolderName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.accountHolderName &&
                  Boolean(formik.errors.accountHolderName)
                }
                helperText={
                  formik.touched.accountHolderName &&
                  formik.errors.accountHolderName
                }
              />
              <TextField
                label="Account Number"
                type="number"
                variant="filled"
                size="small"
                name="accountNumber"
                value={formik.values.accountNumber}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.accountNumber &&
                  Boolean(formik.errors.accountNumber)
                }
                helperText={
                  formik.touched.accountNumber && formik.errors.accountNumber
                }
              />
              <TextField
                label="IFSC Code"
                variant="filled"
                size="small"
                name="ifsc"
                value={formik.values.ifsc}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.ifsc && Boolean(formik.errors.ifsc)}
                helperText={formik.touched.ifsc && formik.errors.ifsc}
              />
              <TextField
                label="Account Type"
                variant="filled"
                size="small"
                name="accountType"
                value={formik.values.accountType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.accountType &&
                  Boolean(formik.errors.accountType)
                }
                helperText={
                  formik.touched.accountType && formik.errors.accountType
                }
                select
              >
                {Constants.Mentor.Account.Types.map((type) => {
                  return (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  );
                })}
              </TextField>
            </div>
          </div>
          <div className=" border-primary  rounded-lg">
            <h1 className="p-4 font-extrabold text-lg">Other Details</h1>
            <div className=" p-5 grid-cols-2 grid gap-5">
              <TextField
                label="Address"
                variant="filled"
                name="address"
                size="small"
                required
                value={formik.values.address}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.address && Boolean(formik.errors.address)}
                helperText={formik.touched.address && formik.errors.address}
              />

              <TextField
                label="Education"
                variant="filled"
                size="small"
                name="education"
                required
                value={formik.values.education}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.education && Boolean(formik.errors.education)
                }
                helperText={formik.touched.education && formik.errors.education}
              />

              <TextField
                label="Profession"
                variant="filled"
                size="small"
                name="profession"
                value={formik.values.profession}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                // error={
                //   formik.touched.profession && Boolean(formik.errors.profession)
                // }
                // helperText={
                //   formik.touched.profession && formik.errors.profession
                // }
                // required
              />

              <TextField
                label="Experience"
                variant="filled"
                size="small"
                name="experience"
                value={formik.values.experience}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.experience && Boolean(formik.errors.experience)
                }
                helperText={
                  formik.touched.experience && formik.errors.experience
                }
                required
              />

              <FormControlLabel
                control={
                  <Switch
                    checked={formik.values.isCounsellingEnabled}
                    onChange={formik.handleChange}
                  />
                }
                label="Mentor Counselling"
                name="isCounsellingEnabled"
              />
              <TextField
                label="Status"
                variant="filled"
                size="small"
                value={formik.values.status}
                name="status"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.status && Boolean(formik.errors.status)}
                helperText={formik.touched.status && formik.errors.status}
                required
                select
              >
                {Constants.Mentor.Status.map((option, index) => {
                  return (
                    <MenuItem key={index} value={option}>
                      {option}
                    </MenuItem>
                  );
                })}
              </TextField>

              {formik.values.isCounsellingEnabled && (
                <>
                  <TextField
                    type="number"
                    label="Counselling Cost Price"
                    defaultValue={0}
                    name="counsellingCostPrice"
                    variant="filled"
                    value={formik.values.counsellingCostPrice}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.counsellingCostPrice &&
                      Boolean(formik.errors.counsellingCostPrice)
                    }
                    helperText={
                      formik.touched.counsellingCostPrice &&
                      formik.errors.counsellingCostPrice
                    }
                    size="small"
                    required
                  />

                  <TextField
                    type="number"
                    label="Counselling Sale Price"
                    variant="filled"
                    defaultValue={0}
                    size="small"
                    name="counsellingSalePrice"
                    value={formik.values.counsellingSalePrice}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.counsellingSalePrice &&
                      Boolean(formik.errors.counsellingSalePrice)
                    }
                    helperText={
                      formik.touched.counsellingSalePrice &&
                      formik.errors.counsellingSalePrice
                    }
                    required
                  />
                </>
              )}

              <TextField
                label="Languages"
                variant="filled"
                size="small"
                name="languages"
                value={formik.values.languages}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.languages && Boolean(formik.errors.languages)
                }
                helperText={formik.touched.languages && formik.errors.languages}
              />

              <TextField
                label="Skills"
                variant="filled"
                size="small"
                name="skills"
                value={formik.values.skills}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.skills && Boolean(formik.errors.skills)}
                helperText={formik.touched.skills && formik.errors.skills}
              />

              <TextField
                label="Description"
                variant="filled"
                size="small"
                multiline
                minRows={3}
                className="col-span-2"
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                helperText={
                  formik.touched.description && formik.errors.description
                }
                name="description"
                required
              />

              <div className="justify-end">
                <Button
                  type="submit"
                  variant="contained"
                  // onClick={formik.handleSubmit}
                >
                  {id ? "Update Profile" : "Create Profile"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      }
    </form>
  );
}

export default EditMentor;
